import GridLayout from './components/GridLayout';
import GridItem from './components/GridItem.vue';
import GridStore from './store/modules/layouts';

/* font awesome stuff */
import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTimesCircle, faArrowsAlt, faCog, faSun, faList, faExpandArrowsAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'

library.add(faTimesCircle, faArrowsAlt, faCog, faSun, faList, faExpandArrowsAlt);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);
Vue.component('font-awesome-layers-text', FontAwesomeLayersText);

export default GridLayout;

export {
    GridLayout,
    GridItem,
    GridStore
}



// WEBPACK FOOTER //
// ./src/lib.js